module.exports = __webpack_public_path__ + "assets/custom-asset-list.9fbd69cc.svg";